import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import { Grid } from "@mui/material";
import TransactionVolumeSection from "./components/TransactionVolumeSection";
import TransactionNumberSection from "./components/TransactionNumberSection";
import TransactionListSection from "./components/TransactionListSection";
import {
  generateUrlWithParams,
  paramParsify,
  paramStringify,
} from "utils/queryParams";
import dayjs from "dayjs";
import { formatDate } from "utils/formatDate";
import InputDateRangePickerComponent from "components/input-date-range-picker/InputDateRangePickerComponent";

const AnalyticsTransactionListPage = ({ setLayoutTitle, setLayoutAction }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = paramParsify(location?.search);
  // change layout title & actions
  useEffect(() => {
    setLayoutTitle(
      <div className='flex flex-row gap-2 items-center'>
        <p
          onClick={() => navigate("/analytics")}
          className='text-[#5F737F80] font-bold cursor-pointer'
        >
          Advanced Analytics
        </p>
        <KeyboardArrowRightOutlinedIcon />
        <p className='font-bold'>Transactions by Affiliated Shareholders</p>
      </div>,
    );

    if (queryParams?.period_start && queryParams?.period_end) {
      const handleOnSelectDate = (payload) => {
        const stringifiedParams = paramStringify({
          ...queryParams,
          page: 1,
          period_start: formatDate.toAPIDate(payload?.value?.dateStart),
          period_end: formatDate.toAPIDate(payload?.value?.dateEnd),
        });
        navigate(generateUrlWithParams(location?.pathname, stringifiedParams), {
          replace: true,
        });
      };
      setLayoutAction(
        <InputDateRangePickerComponent
          valueDateStart={dayjs(queryParams?.period_start)}
          valueDateEnd={dayjs(queryParams?.period_end)}
          maxEndDate={6}
          onSelect={handleOnSelectDate}
          disableWeekends={true}
          limitToFiveYears={true}
        />,
      );
    }

    return () => {
      setLayoutTitle();
      setLayoutAction();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // eslint-disable-next-line react-hooks/exhaustive-deps
    String(queryParams?.period_start),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    String(queryParams?.period_end),
  ]);

  return (
    <div className='analytics-transaction-list-page h-full'>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TransactionVolumeSection />
        </Grid>
        <Grid item xs={6}>
          <TransactionNumberSection />
        </Grid>
        <Grid item xs={12}>
          <TransactionListSection />
        </Grid>
      </Grid>
    </div>
  );
};

export default AnalyticsTransactionListPage;
